module.exports = __webpack_public_path__ + "media/qrcode_tip.3fb2a6b4.wav";